import { ChampionIcon, GiftIcon, StarIcon } from "@hugeicons/core-free-icons";
import { green, red, blue } from "@mui/material/colors/";
import { Paper, Skeleton, Stack, Typography } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";

interface Props {
    isLoading: boolean;
    isSuccess: boolean;
    currentPoints: number;
    totalRedeemed: number;
    totalEarned: number;
}

const LoyaltyAccountSummary = ({ isLoading, isSuccess, currentPoints, totalRedeemed, totalEarned }: Props) => {
    if (isLoading) {
        return (
            <Stack direction="row" spacing={2}>
                <Skeleton variant="rounded" height={250} sx={{ flex: 1 }} />
                <Skeleton variant="rounded" height={250} sx={{ flex: 1 }} />
                <Skeleton variant="rounded" height={250} sx={{ flex: 1 }} />
            </Stack>
        )
    }

    if (!isSuccess) {
        return null;
    }

    return (
        <Stack spacing={2}>
            <Typography variant="h3" mb={2}>
                Puntos
            </Typography>
            <Stack direction="row" spacing={2}>
                <Paper sx={{ flex: 1, overflow: 'hidden' }}>
                    <Stack alignItems="center" justifyContent="center" height={150} sx={{ backgroundColor: blue[500] }}>
                        <HugeiconsIcon icon={StarIcon} size={48} color={blue[50]} />
                    </Stack>
                    <Stack p={2}>
                        <Typography textAlign="center" variant="h2" component="span" fontSize={36}>
                            {currentPoints ?? 0}
                        </Typography>
                        <Typography textAlign="center" variant="body1" color="text.secondary">
                            ACTIVOS
                        </Typography>
                    </Stack>
                </Paper>
                <Paper sx={{ flex: 1, overflow: 'hidden' }}>
                    <Stack alignItems="center" justifyContent="center" height={150} sx={{ backgroundColor: red[500] }}>
                        <HugeiconsIcon icon={GiftIcon} size={48} color={red[50]} />
                    </Stack>
                    <Stack p={2}>
                        <Typography textAlign="center" variant="h2" component="span" fontSize={36}>
                            -{totalRedeemed ?? 0}
                        </Typography>
                        <Typography textAlign="center" variant="body1" color="text.secondary">
                            CANJEADOS
                        </Typography>
                    </Stack>
                </Paper>
                <Paper sx={{ flex: 1, overflow: 'hidden' }}>
                    <Stack alignItems="center" justifyContent="center" height={150} sx={{ backgroundColor: green[500] }}>
                        <HugeiconsIcon icon={ChampionIcon} size={48} color={green[50]} />
                    </Stack>
                    <Stack p={2}>
                        <Typography textAlign="center" variant="h2" component="span" fontSize={36}>
                            +{totalEarned ?? 0}
                        </Typography>
                        <Typography textAlign="center" variant="body1" color="text.secondary">
                            GANADOS
                        </Typography>
                    </Stack>
                </Paper>
            </Stack>
        </Stack>
    )
}

export default LoyaltyAccountSummary;
